import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { UploadStatus } from 'ngx-uploader-esb';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { DeleteDialogService } from './delete-dialog.service';

@Injectable()
export class PlaylistItemDialogService {
  public allowClose: boolean;
  public uploadStatus: UploadStatus = UploadStatus.Done;

  constructor(
    public dialog: MatDialog,
    public deleteDialogService: DeleteDialogService
  ) { }

  public closeWhenUploading(): Observable<boolean> {
    if (this.uploadStatus === UploadStatus.Uploading) {
      return this.deleteDialogService.show('Are you sure you want to exit?');
    }

    return new BehaviorSubject(true).asObservable();
  }
}
